export default __webpack_public_path__ + "static/media/2.87a69d0a.png";